var _a;
import { IdAssetBundleBalloon } from "./IdAssetBundleBalloon";
export var assetBundleBalloon = (_a = {},
    _a[IdAssetBundleBalloon.Balloon_1] = require("../../assets/balloon/Balloon_1.png"),
    _a[IdAssetBundleBalloon.BalloonShadow] = require("../../assets/balloon/BalloonShadow.png"),
    _a);



//////////////////
// WEBPACK FOOTER
// ./src/assetBundles/static/assetBundleBalloon.ts
// module id = 1758
// module chunks = 3